<template>
  <div class="wrapper nav-collapsed menu-collapsed ">
    <nav class="navbar navbar-expand-lg navbar-light bg-faded">
      <div class="container-fluid">
        <div class="navbar-header">
          <img src="/app-assets/img/logo-dravet-diary.png" alt='Logo Dravet Diary'/>
        </div>
        <div class="navbar-container">
          <div id="navbarSupportedContent" class="collapse navbar-collapse">
            <ul class="navbar-nav">
              <li class="dropdown nav-item mt-1"><a id="dropdownBasic" href="#" data-toggle="dropdown" class="nav-link position-relative dropdown-toggle">
                <img :src="'/app-assets/img/flags/' + currentLocale + '.png'" alt="Netherland Flag" class="langimg" v-if="currentLocale" />
                  <i class="ft-flag blue-grey darken-4" v-else></i>
                  <span class="selected-language d-none"></span>
                  </a>
                <div class="dropdown-menu dropdown-menu-right">
                  <div class="arrow_box_right">
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="en" :class="{ 'dropdown-item': true, 'active': currentLocale == 'en'}"><img src="/app-assets/img/flags/en.png" alt="English Flag" class="langimg" /><span> English</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="it" :class="{ 'dropdown-item': true, 'active': currentLocale == 'it'}"><img src="/app-assets/img/flags/it.png" alt="Italian Flag" class="langimg" /><span> Italian</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="fr" :class="{ 'dropdown-item': true, 'active': currentLocale == 'fr'}"><img src="/app-assets/img/flags/fr.png" alt="French Flag" class="langimg" /><span> French</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="es" :class="{ 'dropdown-item': true, 'active': currentLocale == 'es'}"><img src="/app-assets/img/flags/es.png" alt="Spanish Flag" class="langimg" /><span> Spanish</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="de" :class="{ 'dropdown-item': true, 'active': currentLocale == 'de'}"><img src="/app-assets/img/flags/de.png" alt="German Flag" class="langimg" /><span> German</span></a>
                    <a href="javascript:;" @click.prevent="setUserLang" data-lang="nl" :class="{ 'dropdown-item': true, 'active': currentLocale == 'nl'}"><img src="/app-assets/img/flags/nl.png" alt="Netherland Flag" class="langimg" /><span> Netherland</span></a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <router-view :key="$route.fullPath" :current-locale="currentLocale"></router-view>
  </div>  
</template>


<script>
export default {
  data() {
    return {
      currentLocale: 'it'
    }
  },
  created: async function () {
    if (this.$route.query.l)
      this.$i18n.locale = this.$route.query.l
  },
  methods: {
    setUserLang: async function (e) {
      this.$i18n.locale =  e.currentTarget.getAttribute('data-lang')
      this.currentLocale = this.$i18n.locale
    }
  }
}
</script>

<style lang="scss">
  ul.links {
    margin: 0;
    padding: 0;

    li {
      list-style-type: none;
      text-align: center;

      a {
        color: #454545;
        transition: all .5s ease;

        &:hover {
          color: #FF4961;
        }
      }
    }
  }
</style>